import React from 'react';

const AppliedRoute = ({ component: C, props: cProps, ...rest }) => <C {...cProps} />;

export default AppliedRoute;
